// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UserRead } from "./UserRead";
import {
  UserReadFromJSON,
  UserReadFromJSONTyped,
  UserReadToJSON,
  UserReadToJSONTyped,
} from "./UserRead";

/**
 *
 * @export
 * @interface PageUserRead
 */
export interface PageUserRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<UserRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageUserRead interface.
 */
export function instanceOfPageUserRead(value: object): value is PageUserRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageUserReadFromJSON(json: any): PageUserRead {
  return PageUserReadFromJSONTyped(json, false);
}

export function PageUserReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageUserRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(UserReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageUserReadToJSON(json: any): PageUserRead {
  return PageUserReadToJSONTyped(json, false);
}

export function PageUserReadToJSONTyped(
  value?: PageUserRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(UserReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
